// extracted by mini-css-extract-plugin
export default {"search":"Search_search__PQsNp","icon":"Search_icon__pJy84"};